/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { CAMPAIGN_STATE_LABELS, CampaignState } from 'cio/models/campaign';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import SubscriptionCenterService from 'cio/services/subscription-center';
import ObjectTypesService from 'cio/services/object-types';

interface CampaignsFilterGroupArgs {
  filters: any[];
  searchString: string;
  searchTagIds: string[];
  type: string[];
  topic?: string;
  onTagIdsChange: (tagIds: string[]) => void;
  campaignState: CampaignState;
  onCampaignStateChange: (item: { label: string; value: CampaignState }) => unknown;
  onSearch: (searchString: string) => unknown;
  onClearSearch: () => unknown;
  onTopicChange: (topic: { value: string; label: string } | null) => null;
  archived: boolean;
  selectedObjectTypeIds: string[];
  onObjectTypeIdsChange: (objectTypeIds: string[]) => unknown;
}

export default class CampaignsFilterGroup extends Component<CampaignsFilterGroupArgs> {
  @service subscriptionCenter!: SubscriptionCenterService;
  @service objectTypes!: ObjectTypesService;

  campaignStateFilters = [CampaignState.Running, CampaignState.Draft, CampaignState.Stopped].map((s) => ({
    label: CAMPAIGN_STATE_LABELS[s],
    value: s,
  }));

  /* eslint-disable-next-line ember/no-tracked-properties-from-args */
  @tracked searchString = this.args.searchString;

  constructor(owner: unknown, args: CampaignsFilterGroupArgs) {
    super(owner, args);

    this.subscriptionCenter.initializeTask.perform();
  }

  @action
  onSearch() {
    this.args.onSearch(this.searchString);
  }

  @action
  updateSearchString() {
    if (this.args.searchString === this.searchString) {
      return;
    }

    this.searchString = this.args.searchString;
  }
}
